// Design tokens. Warm paper/ink palette with terracotta accent; fonts are
// Fraunces (display serif), Inter (UI), JetBrains Mono (labels/kickers).
// All styling is inline styles referencing PALETTE — no CSS framework.
export const PALETTE = {
  paper:    '#F4EFE6',
  paperDim: '#EAE3D6',
  card:     '#FBF7F0',
  ink:      '#221F1A',
  inkSoft:  '#54504A',
  inkMute:  '#8A847B',
  rule:     '#D9D1C2',
  ruleSoft: '#E5DECF',
  accent:   '#B85230',
  accentDk: '#8C3A1E',
  red:      '#C2402A',
  redSoft:  '#F1D6CD',
  green:    '#3D6B4A',
  blue:     '#3A5878',
};

// Shared top padding for sticky screen headers. Only adds env(safe-area-inset-top)
// on top of a small base — NOT a flat 56px guess at "mobile chrome height":
// in a normal browser tab that inset is 0 (the browser's own address bar
// already sits outside the viewport), and it's only non-zero once the app
// runs standalone on a notched phone (see index.html's viewport-fit=cover).
export const headerPad = (isMobile) =>
  isMobile
    ? 'calc(20px + env(safe-area-inset-top, 0px)) 20px 14px'
    : '28px 28px 14px';
